export default "__VITE_ASSET__YHdMhUmj__"